const AvgHeadCountOpts = {
  paths : [
    [
      '$data/data/counts/byCategory/direct',
      'directHeadCountSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byCategory/direct',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byCategory/indirect',
      'indirectHeadCountSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byCategory/indirect',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/dark',
      'darkSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/dark',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/red',
      'redSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/red',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/gray',
      'graySum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/gray',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/green',
      'greenSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/green',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/mango',
      'mangoSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/mango',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/tydex',
      'tydexSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/tydex',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/white',
      'whiteSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/white',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/maroon',
      'maroonSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/maroon',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/orange',
      'orangeSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/orange',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/darkBlue',
      'darkBlueSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/darkBlue',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [
      '$data/data/counts/byColor/lightBlue',
      'lightBlueSum',
      {
        function : 'SUM',
        args : [
          {
            type : 'field',
            value : [
              '$data/data/counts/byColor/lightBlue',
              null,
              null,
              'integer'
            ]
          }
        ]
      }
    ],
    [ '$data/groupId', 'groupId' ],
    [ '$time', 'maxTime', { function : 'max' } ]
  ],
  group : [
    'groupId'
  ],
  where : [
    [
      '$type',
      '=',
      'occupancy'
    ]
  ],
  outerQuery : {
    paths : [
      [
        '$maxTime',
        'maxTime',
        {
          function : 'max'
        }
      ],
      [
        '$directHeadCountSum',
        'avgDirectHeadCountSum',
        {
          function : 'AVG'
        },
      ],
      [
        '$indirectHeadCountSum',
        'avgInDirectHeadCountSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$graySum',
        'avgGraySum',
        {
          function : 'AVG'
        }
      ],
      [
        '$darkSum',
        'avgDarkSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$darkBlueSum',
        'avgDarkBlueSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$greenSum',
        'avgGreenSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$lightBlueSum',
        'avgLightBlueSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$mangoSum',
        'avgMangoSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$maroonSum',
        'avgMaroonSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$orangeSum',
        'avgOrangeSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$redSum',
        'avgRedSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$tydexSum',
        'avgTydexSum',
        {
          function : 'AVG'
        }
      ],
      [
        '$whiteSum',
        'avgWhiteSum',
        {
          function : 'AVG'
        }
      ],
    ]
  }
}

export default AvgHeadCountOpts
